import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Collection } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-private-content-informer',
  templateUrl: './private-content-informer.component.html',
  styleUrls: ['./private-content-informer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateContentInformerComponent implements OnInit {
  @Input() collections: Collection[];

  @ViewChild('scroller', { read: CdkVirtualScrollViewport })
  scroller: CdkVirtualScrollViewport;
  public isDragScrollEnabled = !(this.deviceService.isMobile() || this.deviceService.isTablet());
  public itemSize = 405;

  constructor(public deviceService: DeviceDetectorService) {}

  ngOnInit(): void {}

  moveLeft() {
    this.scroller.scrollToIndex(0, 'smooth');
  }

  moveRight() {
    const offset = this.scroller.measureScrollOffset('left');
    this.scroller.scrollToOffset(offset + +this.itemSize, 'smooth');
  }

  public trackContentByFn(index, item: Collection): string {
    return item.id;
  }
}
